import {BaseEntityUnDeletable} from '../../../common/entities';

export class InterviewType extends BaseEntityUnDeletable {
    description: string;
}
